import { cn, Icon, Tooltip } from "@kyan/ui";

import { useHelpButtonController } from "./HelpButton.controller";

export const HelpButton: React.FC = () => {
  const { isEoaConnected, handleClick } = useHelpButtonController();

  return (
    <div
      className={cn(
        "border-divider hidden h-full items-center justify-center lg:flex xl:w-10 2xl:w-12",
        { "mr-4 border-l pl-3.5": isEoaConnected, "pr-4": !isEoaConnected },
      )}
    >
      <Tooltip side="bottom" content="Open Help Center">
        <Icon
          size="xl"
          name="help"
          hoverEffect="circle"
          className="flex size-10 items-center justify-center text-[20.5px]"
          onClick={handleClick}
        />
      </Tooltip>
    </div>
  );
};
